import React, { useState } from 'react';
import './directcss/Navbar.scss';
import {
    Collapse,
    Nav,
    Navbar,
    NavbarBrand,
    NavbarToggler,
    NavItem,
} from 'reactstrap';
import { setShowOtherAppsDrawer, setShowPaymentNotAllowedPopup, setShowPrepayWalletDrawer, setShowProfileDrawer, setToggled } from "../DashboardSlice";
import { componentKey as AuthenticationComponentKey } from "../../authentication/AuthenticationSlice";
import { componentKey as DataLoaderComponentKey } from "../../loaders/dataloader/DataLoaderSlice";
import { componentKey as DashboardComponentKey } from "../DashboardSlice";
import Icons from '../../../components/icons/Icons';
import { VEC_ICON_NAME } from '../../../components/icons/constants';
import { useDispatch, useSelector } from 'react-redux';
import TxDropdown from '../../../components/dropdown/txdropdown/TxDropdown';
import styles from './TxNavbar.styles'
import { PAGE_PERMISSIONS } from '../constants/constant';
import { ShowForAllowedPermissionsOnly } from '../../wrappers/ShowForAllowedPermissionsOnly';
import General from '../../../../libs/utility/General';
import Switch from '../../../components/switch/Switch';
import { Theme } from '../../../components/constants';
import { isAccessAllowed, useUserPermissionsInfo } from '../hooks/userHooks';
import { getSwitchExchangeToken } from '../../appswitch/AppSwitchSaga';
import useTxNavigate from '../../../../libs/txnavigate/TxNavigateHook';
import Config from '../../../config.web';

export default function TxNavbar() {

    const [isOpen, setIsOpen] = useState(false);
    const [showCreateNewMenu, setShowCreateNewMenu] = useState(false);
    const [showShortcutMenu, setShowShortcutMenu] = useState(false);
    const toggleNavbar = () => setIsOpen(!isOpen);
    const { signedInUser } = useSelector((state) => state[AuthenticationComponentKey])
    const { prepayAmount } = useSelector((state) => state[DataLoaderComponentKey])
	const { onboardingPending, showOtherAppsDrawer, errorInProfile } = useSelector((state) => state[DashboardComponentKey])

    const { permissions } = useUserPermissionsInfo();

    const navigate = useTxNavigate();
    const dispatch = useDispatch();

    const getUserName = () => {
        return `${signedInUser?.FirstName ?? ""} ${signedInUser?.MiddleName ?? ""} ${signedInUser?.LastName ?? ""}`;
    }

    const toggleCreateNewDropDown = () => {
        setShowCreateNewMenu(prev => !prev);
    }

    const toggleShortcutDropDown = () => {
        setShowShortcutMenu(prev => !prev);
    }

    const SHORTCUTS_LABEL = {
        FILE_SHARE: "File Share",
        CHECK_ON_STATUS: "Check Status",
        GENERATE_SUMMARY: "Generate Summary (1096/ACA)",
        MANAGE_EXTENSION: "Manage Extension Forms (8809)",
    }
    const CREATE_NEW_LABEL = {
        FORMS: "Forms",
        PAYERS: "Payers",
        RECIPIENT: "Recipient",
        DIVIDER: "divider",
        USER: "User",
        NOTICES: "Notices",
    }

    const SHORTCUTS_MENU = [
        SHORTCUTS_LABEL.FILE_SHARE,
        SHORTCUTS_LABEL.CHECK_ON_STATUS,
        SHORTCUTS_LABEL.GENERATE_SUMMARY,
        SHORTCUTS_LABEL.MANAGE_EXTENSION
    ]

    const CREATE_NEW_MENU = [
        { Name: CREATE_NEW_LABEL.FORMS, permissions: '' },
        { Name: CREATE_NEW_LABEL.PAYERS, permissions: PAGE_PERMISSIONS.CREATE_PAYERS },
        { Name: CREATE_NEW_LABEL.RECIPIENT, permissions: PAGE_PERMISSIONS.CREATE_RECIPIENT },
        { Name: CREATE_NEW_LABEL.DIVIDER, permissions: '' },
        { Name: CREATE_NEW_LABEL.USER, permissions: PAGE_PERMISSIONS.CREATE_USER },
        { Name: CREATE_NEW_LABEL.NOTICES, permissions: PAGE_PERMISSIONS.VIEW_NOTICES },
    ]

    const dropDownNavigate = (destination) => {
        switch (destination) {
            case SHORTCUTS_LABEL.FILE_SHARE:
                navigate("/fileshare")
                break;
            case SHORTCUTS_LABEL.CHECK_ON_STATUS:
                navigate("/checkstatus")
                break;
            case SHORTCUTS_LABEL.GENERATE_SUMMARY:
                navigate("/generatesummary")
                break;
            case SHORTCUTS_LABEL.MANAGE_EXTENSION:
                navigate("/manageextensionform")
                break;
            case CREATE_NEW_LABEL.FORMS:
                navigate("/forms/createnew")
                break;
            case CREATE_NEW_LABEL.PAYERS:
                navigate("/payer/add")
                break;
            case CREATE_NEW_LABEL.RECIPIENT:
                navigate("/recipient/add")
                break;
            case CREATE_NEW_LABEL.USER:
                navigate("/users/manageusers?action=adduser")
                break;
            case CREATE_NEW_LABEL.NOTICES:
                navigate("/notices?action=addnotice")
                break;


        }
    }

    const handleLogoClick = () => {
        navigate("/")
    }

    const handleClassicViewSwitchClick = () => {
        dispatch(getSwitchExchangeToken({source: ""}))
    }

    return (
        <Navbar className="tx-navbar" light expand="lg" container={false}>
            <NavbarToggler onClick={() => dispatch(setToggled(true))} className="navbar-toggler" />
            <div style={styles.allMenuIconDivStyles} onClick={() => dispatch(setShowOtherAppsDrawer(!showOtherAppsDrawer)) }><Icons familyName={'vec'} iconName={VEC_ICON_NAME.ALL_MENU_ICON}/></div>
            <NavbarBrand onClick={handleLogoClick} href="/#/"><Icons familyName='vec' iconName={VEC_ICON_NAME.TAX1099_LOGO} style={styles.navbarLogoStyles} /></NavbarBrand>
            <NavbarToggler onClick={toggleNavbar} className="navbar-toggler" />
            <Collapse className="tx-navbar-collapse" isOpen={isOpen} navbar >
                <Nav navbar className='full-height'>
                    <NavItem>
                        <div className="tx-nav-item cursor-pointer">
                            <span className='nav-item-label'>Classic View</span>
                            <Switch isOn={true} name={"ClassicViewSwitchOn"} switchUniqueId={"classicview-switch"} onColor={Theme.SECONDARY} handleToggleCb={ handleClassicViewSwitchClick } customSwitchLabelStyle={styles.switchLabelCustomStyle} customSwitchButtonStyle={styles.switchButtonCustomStyle} />
                            <span className='nav-item-label'>Modern View</span>
                        </div>
                    </NavItem>
                    {
                        !onboardingPending && !errorInProfile &&
                            <>
                                <NavItem className='full-height display-flex left-pipe'>
                                    <div className="tx-nav-item cursor-pointer">
                                        <TxDropdown
                                            isOpen={showCreateNewMenu}
                                            toggleCb={toggleCreateNewDropDown}
                                            iconLabelProps={{ label: "Create New", iconName: VEC_ICON_NAME.CIRCULAR_PLUS_ICON, familyName: "vec", styles: {} }}
                                            DropdownMenuComponent={
                                                <div className='flex-column'>
                                                    {CREATE_NEW_MENU.map(menu => {
                                                        if (menu.Name === "divider") {
                                                            return <div className='dropdown-divider'></div>
                                                        }
                                                        return <ShowForAllowedPermissionsOnly toCheck={menu.permissions}>
                                                            <div className='dropdown-item' onClick={() => dropDownNavigate(menu.Name)}>{menu.Name}</div>
                                                        </ShowForAllowedPermissionsOnly>
                                                    })}
                                                </div>
                                            }
                                        />
                                    </div>
                                </NavItem>
                                <NavItem>
                                    <div className="tx-nav-item cursor-pointer" onClick={() => {
                                            if(isAccessAllowed(PAGE_PERMISSIONS.PAYMENTS, permissions )) {
                                                dispatch(setShowPrepayWalletDrawer(true))
                                            } else {
                                                dispatch(setShowPaymentNotAllowedPopup(true))
                                            }
                                        }}>
                                        <Icons familyName='vec' iconName={VEC_ICON_NAME.WALLET_ICON} />
                                        <span className='nav-item-label'>$ {General.getDecimalAmount(prepayAmount)}</span>
                                    </div>
                                </NavItem>
                                <NavItem className='full-height display-flex'>
                                    <div className="tx-nav-item cursor-pointer">
                                        <TxDropdown
                                            isOpen={showShortcutMenu}
                                            toggleCb={toggleShortcutDropDown}
                                            iconLabelProps={{ label: "Shortcuts", iconName: VEC_ICON_NAME.SHORTCUT_ICON, familyName: "vec", styles: {} }}
                                            DropdownMenuComponent={
                                                <div className='flex-column'>
                                                    {SHORTCUTS_MENU.map(shortcut => <div className='dropdown-item' onClick={() => dropDownNavigate(shortcut)}>{shortcut}</div>)}
                                                </div>
                                            }
                                        />
                                    </div>
                                </NavItem>
                            </>
                    }
                    <NavItem className=" full-height display-flex left-pipe">
                        <div className="tx-nav-item cursor-pointer" onClick={() => { dispatch(setShowProfileDrawer(true)) }}>
                            <Icons familyName='vec' iconName={VEC_ICON_NAME.USER_ICON} style={styles.iconHW25} />
                            <span className='nav-item-label'>{getUserName()}</span>
                            <Icons familyName='vec' iconName={VEC_ICON_NAME.CARET_DOWN} color={'#262626'} />
                        </div>
                    </NavItem>
                </Nav>
            </Collapse>
        </Navbar>
    )
}